var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelefone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5582 52.3432C41.5582 52.3432 39.0761 54.7539 38.4679 55.4606C37.477 56.5062 36.3096 57 34.7792 57C34.632 57 34.4751 57 34.3279 56.9903C31.4142 56.8064 28.7066 55.6833 26.6758 54.7248C21.1231 52.0721 16.2474 48.306 12.1957 43.533C8.85034 39.5539 6.61357 35.8749 5.13221 31.9248C4.21984 29.5141 3.88629 27.6359 4.03344 25.8642C4.13155 24.7315 4.57301 23.7924 5.38727 22.9888L8.73261 19.6874C9.21332 19.242 9.72346 19 10.2238 19C10.8418 19 11.3422 19.3679 11.6561 19.6777C11.6659 19.6874 11.6757 19.6971 11.6855 19.7068C12.284 20.2586 12.853 20.8298 13.4514 21.4397C13.7555 21.7496 14.0695 22.0594 14.3834 22.3789L17.0616 25.0219C18.1015 26.0482 18.1015 26.9969 17.0616 28.0232C16.7771 28.304 16.5024 28.5847 16.2179 28.8558C15.3939 29.6884 16.0412 29.0496 15.1877 29.8047C15.1681 29.8241 15.1485 29.8338 15.1387 29.8531C14.295 30.6857 14.4519 31.499 14.6285 32.0508C14.6383 32.0799 14.6481 32.1089 14.658 32.138C15.3545 33.8032 16.3355 35.3716 17.8267 37.2401L17.8365 37.2498C20.5442 40.5415 23.399 43.1071 26.5481 45.0725C26.9504 45.3242 27.3624 45.5275 27.7548 45.7211C28.108 45.8954 28.4415 46.06 28.726 46.2343C28.7653 46.2536 28.8045 46.2827 28.8438 46.302C29.1773 46.4666 29.4913 46.5441 29.815 46.5441C30.6293 46.5441 31.1394 46.0406 31.3062 45.876L33.2291 43.9783C33.5627 43.6492 34.0925 43.2522 34.7105 43.2522C35.3188 43.2522 35.8191 43.6298 36.1232 43.959C36.133 43.9687 36.133 43.9687 36.1428 43.9783L41.5483 49.3129C42.5588 50.3004 41.5582 52.3432 41.5582 52.3432Z",
    fill: "url(#paint0_linear_1_1526)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1526",
    x1: 23,
    y1: 19,
    x2: 23,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#64C2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484C89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefone);
export default __webpack_public_path__ + "static/media/telefone.c93dcac18b675576950029ec3d9cffac.svg";
export { ForwardRef as ReactComponent };